import React from "react";

const DefaultView = (props) => {
  return (
    <div
      className="flex-stretch"
      style={{ display: "flex", alignItems: "center" }}
    >
      <img
        src="logo.png"
        alt="Logo"
        id="logo"
        style={{ maxWidth: "40%", margin: "0px auto" }}
      />
    </div>
  );
};

export default DefaultView;
